/**
 * Resource danh mục tài khoản kết chuyển
 * pntoan 15.5.2024
 */
export default {
  Title: 'Tài khoản kết chuyển',
  Dictionary: 'Danh mục',
  FolderPath: '/ Tài khoản / Tài khoản kết chuyển',
  AccountTransferCode: 'Mã KC *',
  AccountTransferCodeTooltip: 'Mã kết chuyển',
  TransferOrder: 'Thứ tự KC *',
  TransferOrderTooltip: 'Thứ tự kết chuyển',
  TransferSide: 'Bên KC',
  TransferSideTooltip: 'Bên kết chuyển',
  FromAccount: 'Từ tài khoản *',
  ToAccount: 'Đến tài khoản *',
  Description: 'Diễn giải',
};
